module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isOpen) ? _c('div', {
    staticClass: "pop-up"
  }, [_c('div', {
    staticClass: "pop-up-box"
  }, [_c('h5', {
    staticClass: "h5 c-accent mt0 mb0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('p', {
    staticClass: "p mt0 small"
  }, [_vm._v(_vm._s(_vm.copy))]), _vm._v(" "), _c('module-button', {
    staticClass: "mt-tiny mr-tiny",
    attrs: {
      "button": "primary",
      "label": _vm.button.label
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hitLogin.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('module-button', {
    staticClass: "mt-tiny ml0 mr0",
    attrs: {
      "label": "Close"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeBox.apply(null, arguments)
      }
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d47fb5f6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/PopUp.vue
// module id = 425
// module chunks = 0